var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    { 'no-margin-left': !this.$store.state.auth.status.loggedIn },
    'layout-footer',
    'p-text-right',
    'p-text-bold',
  ]},[_c('span',{staticClass:"footer-text p-mr-2"},[_vm._v("W4M Digital Solutions")]),_c('img',{attrs:{"src":require("./assets/logo.png"),"alt":"w4m","width":"50"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }